import React from 'react';
import format from './format';

const lowerToUpper = (value, paddingLeft) => {
    return (
        !isNaN(parseFloat(value)) ?
            <div style={{paddingTop: 0, paddingBottom: 0}}>
                <div className="item" style={{paddingLeft: paddingLeft || 210, whiteSpace: 'initial'}}>
                    <span className="ui-text">
                        {
                            !isNaN(parseFloat(value)) &&
                            <span style={{color: 'blue'}}>{format('smalltoBIG', parseFloat(value))}</span>
                        }
                    </span>
                </div>
            </div>
        :
            null
    );
};

const lineFeed = (string, sepatator = ';', count = 1) => {
    return (string || '')
        .split(sepatator)
        .map((item, index, { length }) => (
            <span>{item}{index < length - 1 && sepatator}{(index + 1) % count === 0 && <br />}</span>
        ));
};

function SmallToBig({ value }) {
    const newValue = parseFloat(value);
    return (
        !isNaN(newValue) && <div className="smallToBig">{format('smalltoBIG', newValue)}</div>
    );
}

export { lineFeed, lowerToUpper, SmallToBig };


// WEBPACK FOOTER //
// ./src/components/shared/formatElem.js